import * as React from 'react';
import { ModalDialog } from '../../components/modal-dialog';

let errorDialog = (error = { ErrorMessage: 'There was a problem setting up the integration' }, title?:string) =>
	<ModalDialog title={title}>{error.ErrorMessage}</ModalDialog>;


export { errorDialog as ErrorDialog };
